/**
 * Auth-endpoints (ADM-150).
 *
 * Inloggningsflödet är redirect-baserat:
 *   1. login() — sätter window.location = /api/auth/login → Keycloak
 *   2. Keycloak autentiserar, redirectar till /api/auth/callback
 *   3. Backend sätter HttpOnly-cookie + redirectar till frontend root
 *   4. Frontend mount:ar, kör getCurrentUser() för att se om vi är inloggade
 *
 * getCurrentUser() returnerar null om ingen giltig session finns (401).
 */

import { http } from './httpClient';
import { HttpError } from './errors';

export function login({ returnTo = '/' } = {}) {
  const base = typeof window !== 'undefined' ? window.location.origin : '';
  const url = new URL('/api/auth/login', base);
  if (returnTo) url.searchParams.set('returnTo', returnTo);
  if (typeof window !== 'undefined') {
    window.location.assign(url.toString());
  }
}

export async function logout() {
  try {
    const result = await http.post('/auth/logout');
    const endSessionUrl = result.raw && result.raw.endSessionUrl;
    if (endSessionUrl && typeof window !== 'undefined') {
      window.location.assign(endSessionUrl);
      return { redirected: true };
    }
    return { redirected: false };
  } catch (err) {
    // Även om backend-logout failar, försök clear:a lokal state
    if (typeof window !== 'undefined') {
      window.location.assign('/');
    }
    return { redirected: false, error: err };
  }
}

export async function getCurrentUser() {
  try {
    const result = await http.get('/auth/me');
    return result.data;
  } catch (err) {
    if (err instanceof HttpError && err.isUnauthorized) return null;
    throw err;
  }
}
